<template>
  <div class="page">
    <health v-if="tableInfo&&tableInfo.shortMatch&&tableInfo.shortMatch=='身体状况'"
            :tableInfo="tableInfo" :signUrl="signUrl" :stu_id="stu_id" :pmid="pmid"></health>

    <uniform v-if="tableInfo&&tableInfo.shortMatch&&tableInfo.shortMatch=='校服'"
             :tableInfo="tableInfo" :stu_id="stu_id" :pmid="pmid"
             :signUrlStu="signUrlStu" :signUrlParent="signUrlParent"></uniform>

    <stuInfo v-if="tableInfo&&tableInfo.shortMatch&&tableInfo.shortMatch=='学生信息'"
             :tableInfo="tableInfo" :stu_id="stu_id" :pmid="pmid"></stuInfo>

    <perInfo v-if="tableInfo&&tableInfo.shortMatch&&tableInfo.shortMatch=='个人信息'"
             :tableInfo="tableInfo" :stu_id="stu_id" :pmid="pmid"></perInfo>

    <otherInfo v-if="tableInfo&&tableInfo.shortMatch&&tableInfo.shortMatch=='其他信息'"
             :tableInfo="tableInfo" :stu_id="stu_id" :pmid="pmid"></otherInfo>

    <dorm v-if="tableInfo&&tableInfo.shortMatch&&tableInfo.shortMatch=='住宿'"
               :tableInfo="tableInfo" :stu_id="stu_id" :pmid="pmid"></dorm>

  </div>
</template>

<script>
import {
  Toast
} from 'vant';
import health from './com/bd_health';
import uniform from './com/bd_uniform';
import stuInfo from './com/bd_stuInfo';
import perInfo from './com/bd_perInfo';
import otherInfo from './com/bd_otherInfo';
import dorm from './com/bd_dorm';

export default {
  components: {
    health,uniform,stuInfo,perInfo,otherInfo,dorm
  },
  data() {
    return {
      tableInfo: {},
      signUrl: '',
      pmid:0,
      stu_id: 0,
      signUrlStu: '',
      signUrlParent: '',
    }
  },
  mounted() {
    let _this = this
    $(".page").height($(window).height())
    console.log(this.$route.params)
    if(this.$route.params&&this.$route.params.item){
      this.tableInfo = this.$route.params.item
      document.title = this.$route.params.item.table_name
      this.stu_id = Number(this.$route.params.stu_id)
      this.pmid = Number(this.$route.params.pmid)
      if(this.tableInfo.table_name&&this.tableInfo.table_name.indexOf('身体状况')!=-1){
        this.tableInfo.shortMatch = '身体状况'
      }
      if(this.tableInfo.table_name&&this.tableInfo.table_name.indexOf('校服')!=-1){
        this.tableInfo.shortMatch = '校服'
      }
      if(this.tableInfo.table_name&&this.tableInfo.table_name.indexOf('学生信息')!=-1){
        this.tableInfo.shortMatch = '学生信息'
      }
      if(this.tableInfo.table_name&&this.tableInfo.table_name.indexOf('个人信息')!=-1){
        this.tableInfo.shortMatch = '个人信息'
      }
      if(this.tableInfo.table_name&&this.tableInfo.table_name.indexOf('其他信息')!=-1){
        this.tableInfo.shortMatch = '其他信息'
      }
      if(this.tableInfo.table_name&&this.tableInfo.table_name.indexOf('住宿')!=-1){
        this.tableInfo.shortMatch = '住宿'
      }
    }
    else if(this.$route.query) {
      console.log(79,this.$route.query)
      this.stu_id = Number(this.$route.query.stu_id)
      this.pmid = Number(this.$route.query.pmid)
      if(this.$route.query.shortmatch.indexOf('身体状况')!=-1){
        this.tableInfo.shortMatch = '身体状况'
      }
      if(this.$route.query.shortmatch.indexOf('校服')!=-1){
        this.tableInfo.shortMatch = '校服'
      }
      if(this.$route.query.shortmatch.indexOf('学生信息')!=-1){
        this.tableInfo.shortMatch = '学生信息'
      }
      if(this.$route.query.shortmatch.indexOf('个人信息')!=-1){
        this.tableInfo.shortMatch = '个人信息'
      }
      if(this.$route.query.shortmatch.indexOf('其他信息')!=-1){
        this.tableInfo.shortMatch = '其他信息'
      }
      if(this.$route.query.shortmatch.indexOf('住宿')!=-1){
        this.tableInfo.shortMatch = '住宿'
      }
      if(this.$route.query.signurl){
        this.signUrl = decodeURIComponent(this.$route.query.signurl)
        console.log(102,this.signUrl)
      }
      if(this.$route.query.signurlstu){
        this.signUrlStu = decodeURIComponent(this.$route.query.signurlstu)
      }
      if(this.$route.query.signurlparent){
        this.signUrlParent = decodeURIComponent(this.$route.query.signurlparent)
      }
    }
    this.tableInfo = {..._this.tableInfo}
    console.log(this.tableInfo)
  },
  methods: { },
}
</script>

<style lang="less" type="text/less">
.page{
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}
</style>
